import r from"react";var e=function(e){var t=e.providers;void 0===t&&(t=[]);var n=e.children;return t.length<0?n:t.reduce(function(e,t){return r.createElement(t,[],e)},n)};export{e as Compose};
//# sourceMappingURL=compose.mjs.map
